import React, { useState, useEffect,  useContext } from 'react';
import './AverageResponse.css';
import DropDown from '../DropDown/DropDown';
import { CardAverageResponseContext } from '../../contexts/CardAverageResponseContext';
import logComponent from '../../common/logComponent';

export default function AverageAlarmResponseTimeRange({ updateTimeRange }) {
  const cardAverageResponseContext = useContext(CardAverageResponseContext);
  const [currentTimeRange, setCurrentTimeRange] = useState(null);
  const { timeRanges } = cardAverageResponseContext;

  useEffect(() => {
    if (logComponent('AverageAlarmResponseTimeRange')) {console.debug('AverageAlarmResponseTimeRange useEffect [cardAverageResponseContext.averageResponseTimeRange ]'); }
    setCurrentTimeRange(cardAverageResponseContext.averageResponseTimeRange);

  }, [cardAverageResponseContext.averageResponseTimeRange]);


  if (logComponent('AverageAlarmResponseTimeRange')) { console.debug('AverageAlarmResponseTimeRange rendered'); }


  return (
    <DropDown className="Average-Response__drop-down" items={timeRanges} selectedItem={currentTimeRange} onSelect={updateTimeRange} />
  );
}